export default {"src":"/_next/static/media/Osteoarthritis jhk.b6ea217d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};